/**
 * Normalize a user-entered site URL.
 *
 * Trims surrounding whitespace and prepends `https://` when the user typed a
 * bare domain (no scheme). This mirrors the FREE scan flow so a buyer can type
 * `example.ch` or `www.example.ch` and have it accepted rather than rejected.
 *
 * Returns the (possibly prefixed) string as-is — call `new URL()` on the
 * result to confirm it is a plausible URL before submitting.
 */
export function normalizeUrl(input: string): string {
  let v = input.trim();
  if (v && !/^https?:\/\//i.test(v)) v = "https://" + v;
  return v;
}
